import { BaseEntity } from "./base-entity";

export class Doctor extends BaseEntity {
  UserAccountId: number;
  RegistrationNumber: string;
  PracticeName: string;
  Qualification: any;
  Specialization: any;
  AboutMe: string;
  OfficeContactName: string;
  IsApproved: string;
  Description: string;
  constructor() {
    super();
    this.RegistrationNumber = null;
    this.PracticeName = null;
    this.Qualification = null;
    this.Specialization = null;
    this.AboutMe = null;
    this.OfficeContactName = null;
    this.IsApproved = "";
    this.Description = null;
  }
}
